export default {
	forms: {
		edit: {
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					locality: {},
					name: {},
					name_full: {
						config: {
							visible: false
						}
					},
					category_eva: {}
				}
			}
		},
		list: {
			config: {
				sorting: true,
				fields: {
					id: {
						config: {
							hide: true
						}
					},
					locality: {},
					name_full: {}
				}
			}
		},
		select: {
			panel: {
				width: '80%'
			},
			config: {
				fields: {
					id: {
						config: {
							hide: true
						}
					},
					locality: {},
					name: {}
				}
			}
		}
	}
}